export default __webpack_public_path__ + "static/media/et.103489c0.svg";